import { render, staticRenderFns } from "./SaiInput.vue?vue&type=template&id=090da752"
import script from "./SaiInput.vue?vue&type=script&lang=js"
export * from "./SaiInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports